var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.2q-2.125 0-3.988-.8-1.862-.8-3.237-2.175Q3.4 17.85 2.6 15.988 1.8 14.125 1.8 12t.8-3.988q.8-1.862 2.175-3.237Q6.15 3.4 8.012 2.6 9.875 1.8 12 1.8t3.988.8q1.862.8 3.237 2.175Q20.6 6.15 21.4 8.012q.8 1.863.8 3.988t-.8 3.988q-.8 1.862-2.175 3.237Q17.85 20.6 15.988 21.4q-1.863.8-3.988.8Zm-.2-2.3-.575-.575q-.15-.15-.225-.337-.075-.188-.075-.388v-5.525q-.825-.05-1.412-.65-.588-.6-.588-1.425v-.975l-3.05-3.05Q5.025 8 4.55 9.275T4.075 12q0 3.275 2.237 5.562Q8.55 19.85 11.8 19.9Zm1.275-.05q2.9-.4 4.875-2.612 1.975-2.213 1.975-5.238 0-3.3-2.312-5.613Q15.3 4.075 12 4.075q-1.075 0-2.075.275-1 .275-1.85.775v1.8h3.475q.475 0 .9.2.425.2.7.575l1.375 1.725H16q.45 0 .762.312.313.313.313.763v1.05q0 .225-.063.437-.062.213-.187.438l-3.75 5.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegions);
export default __webpack_public_path__ + "static/media/regions.58275d04902debab46be12db0711da00.svg";
export { ForwardRef as ReactComponent };